import { useContext, useMemo } from 'react';
import { FormattedNumber } from 'react-intl';

import { PortfolioPrivacyContext } from './PortfolioPrivacyContext';
import { PrivacyContextAwareProps } from './PrivacyContextAwareProps';

export const PrivacyContextAwareMoneyValue = ({ length, value, noDecimals, displaySign }: PrivacyContextAwareProps) => {
  const { isPrivacyModeEnabled } = useContext(PortfolioPrivacyContext);

  const hiddenDisplay = useMemo(() => '*'.repeat(length), [length]);

  const hideInsignificantDecimals = useMemo(() => noDecimals && value % 1 === 0, [noDecimals, value]);
  return isPrivacyModeEnabled ? (
    <>{hiddenDisplay}</>
  ) : (
    <FormattedNumber
      style="currency"
      currency="USD"
      value={value}
      signDisplay={displaySign ? 'always' : undefined}
      minimumFractionDigits={hideInsignificantDecimals ? 0 : undefined}
      maximumFractionDigits={hideInsignificantDecimals ? 0 : undefined}
    />
  );
};
